import {
  SHOW_ERROR_COMPONENT,
  HIDE_ERROR_COMPONENT
} from "./ActionConstant";

export function showErrorComponent(data) {
  return {
    type: SHOW_ERROR_COMPONENT,
    data,
  };
}

export function hideErrorComponent(data) {
  return {
    type: HIDE_ERROR_COMPONENT,
    data,
  };
}
